import React from 'react';
import {Button} from "antd";

const ConditionalButton = ({handleOnClick, className, color, variant, children, isVisible}) => {
    return (
        <>
            {
                isVisible && <Button
                    onClick={handleOnClick}
                    className={className}
                    type={"button"}
                    color={color} variant={variant}
                >
                    {children}
                </Button>
            }
        </>
    );
};

export default ConditionalButton;